import React from 'react';
import PropTypes from 'prop-types';

import SocialAccountChip from '../containers/SocialAccountChip';
import SelectableChip from './SelectableChip/SelectableChip';

const SocialAccountOption = ({socialAccount, ...other}) => {
  return (
    <SelectableChip className='col-xs-12' {...other}>
      <SocialAccountChip socialAccount={socialAccount} size='sm' />
    </SelectableChip>
  );
};

SocialAccountOption.propTypes = {
  socialAccount: PropTypes.object.isRequired
};

export default SocialAccountOption;
